const projects = [
	{
		name: "Personal Website",
		ghLink: "https://github.com/csong202/csong202.github.io",
		description: [
			"Created a frontend web application from scratch using React, Typescript, HTML, and Tailwind CSS",
			"Implemented a mobile-desktop responsive design",
			"Designed a logo and icon using Adobe Fresco",
		],
	},
	{
		name: "Check My Attendance",
		ghLink: "https://github.com/diegobajetti/check-my-attendance",
		description: [
			"Collaborated in a group with three other students to create a web application that uses facial recognition to take student attendance",
			"Created a user interface using React, JavaScript, HTML, and CSS",
			"Created Redux actions and reducers to for student sign in/registration, course attendance selection, professor sign in, and attendance records",
			"Added search feature for authorized professors to search attendance records by student name or id",
		],
	},
	{
		name: "AuctionDApp - DeFi the Conventional Hackathon 2022",
		ghLink: "https://github.com/csong202/AuctionDApp",
		description: [
			"Created smart contracts using Rust and CosmWasm",
			"Created the frontend using Terra.js along with React, JavaScript, HTML, and SCSS",
			"Won second place in the Tooling category out of 239 participants",
		],
	},
	{
		name: "Go Fish",
		ghLink: "https://github.com/csong202/CardGames",
		description: [
			"C++ program that plays Go Fish against the user",
			"Manually managed heap allocations to store cards and other game variables",
		],
	},
	{
		name: "Tic Tac Toe Discord Bot",
		ghLink: "https://github.com/csong202/discord-bot2",
		description: [
			"Discord bot written in Golang that plays tic tac toe against the user",
			"Implemented the minimax algorithm to determine the bot's moves",
		],
	},
];

export default projects;
